var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Copy",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8097",
    "data-name": "Rectangle 8097",
    width: 16,
    height: 16,
    transform: "translate(461 1094)",
    fill: "#102d6f",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_6635",
    "data-name": "Mask Group 6635",
    transform: "translate(-461 -1094)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35249",
    "data-name": "Path 35249",
    d: "M13.25,0H4.57a.749.749,0,0,0-.75.75V3.81H.75A.755.755,0,0,0,0,4.56v8.69A.755.755,0,0,0,.75,14H9.44a.755.755,0,0,0,.75-.75V10.18h3.06A.749.749,0,0,0,14,9.43V.75A.743.743,0,0,0,13.25,0M8.69,12.5H1.5V5.31H8.69ZM12.5,8.68H10.19V4.56a.755.755,0,0,0-.75-.75H5.32V1.5H12.5Z",
    transform: "translate(462 1095)",
    fill: "#3d72fc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.c67a712b25cbd494387af47a967aead6.svg";
export { ForwardRef as ReactComponent };